// extracted by mini-css-extract-plugin
export default {"experience":"styles_experience__hS2c-"};